"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AttachmentScanStatusSchema () {
        return AttachmentScanStatusSchema;
    },
    get PatientAttachmentCreateResponseSchema () {
        return PatientAttachmentCreateResponseSchema;
    },
    get PatientAttachmentListResponseSchema () {
        return PatientAttachmentListResponseSchema;
    },
    get PatientAttachmentSchema () {
        return PatientAttachmentSchema;
    }
});
const _zod = require("zod");
const _attachmentkind = require("./attachment-kind");
const AttachmentScanStatusSchema = _zod.z.enum([
    'not_scanned',
    'clean',
    'infected'
]);
const PatientAttachmentSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    kind: _attachmentkind.AttachmentKindSchema,
    fileName: _zod.z.string().min(1).max(_attachmentkind.ATTACHMENT_FILE_NAME_MAX),
    sizeBytes: _zod.z.number().int().min(1).max(_attachmentkind.ATTACHMENT_MAX_BYTES),
    scanStatus: AttachmentScanStatusSchema,
    createdAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
const PatientAttachmentListResponseSchema = _zod.z.object({
    items: _zod.z.array(PatientAttachmentSchema),
    total: _zod.z.number().int().min(0)
});
const PatientAttachmentCreateResponseSchema = PatientAttachmentSchema;
